import Modal from './components/Modal';

export default (props) => {
  switch (props.decorator || props.is) {
  case 'GoogleRecaptcha':
    // COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
    return import('fg-frontend/src/components/GoogleRecaptcha');

	  case 'Modal':return Modal;
  default:
    return null;
  }
};



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/configureWebComponents.js